export default __webpack_public_path__ + "static/media/Shape.0c3f448d.svg";